import axios from "axios";
import { updateError } from "../Features/ErrorBoundaryStrategySlice";
import {
  closeProgressModal,
  openProgressModal,
} from "../Features/UtilityDataSlice";
import { convertObjectValuesToStrings } from "./CommonServices";
import { SESSION_AUTH_TOKEN } from "../Constants/CommonConstants";
import { performLogout } from "../Features/AuthorizationSlice";

let store;

export const injectStore = (_store) => {
  store = _store;
};

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    config.data =
      config?.data?.fetchNotification === false ||
      config?.data?.archive === false ||
      config?.data?.fetchOverrideEligRequestList === false
        ? config.data
        : convertObjectValuesToStrings(config.data);
    const authToken = sessionStorage.getItem(SESSION_AUTH_TOKEN);
    store.dispatch(openProgressModal());
    if (authToken) {
      config.headers["X-AUTH-TOKEN"] = authToken;
    } else {
      const loginToken = store.getState().login.loginToken;
      config.headers["X-LOGIN-TOKEN"] = loginToken;
    }
    config.headers["Cache-Control"] = "no-cache";
    config.headers.Pragma = "no-cache";
    config.headers.Expires = "0";
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    store.dispatch(closeProgressModal());
    return response;
  },

  (err) => {
    if (err?.response?.status === 403 || err?.response?.status === 302) {
      store.dispatch(performLogout());
    } else if (
      err?.response?.status !== 200 &&
      err?.response?.status !== 201 &&
      err?.response?.status !== 406
    ) {
      store.dispatch(updateError(err));
    }
    store.dispatch(closeProgressModal());
    return Promise.reject(err);
  }
);

export default api;
